import React from 'react';
import { motion } from 'framer-motion';
export function HeroSection() {
  return <section className="relative bg-gradient-to-br from-[#1A2744] via-[#2D3E6B] to-[#1A4060] text-white py-20 md:py-24 px-5 text-center overflow-hidden" data-id="element-303">
      <div className="absolute inset-0 pointer-events-none" data-id="element-304">
        <div className="absolute -top-1/2 -left-1/2 w-[200%] h-[200%] bg-[radial-gradient(circle,rgba(244,165,53,0.08)_0%,transparent_60%)]" data-id="element-305" />
      </div>

      <div className="relative z-10 max-w-5xl mx-auto" data-id="element-306">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} data-id="element-307">
          <div className="inline-block bg-[#F4A535] text-[#1A2744] text-xs font-bold tracking-[2px] uppercase px-5 py-2 rounded-full mb-8" data-id="element-308">
            ⭐ Especial para padres de preadolescentes y adolescentes
          </div>

          <h1 className="text-4xl md:text-6xl lg:text-7xl font-black leading-tight mb-3" data-id="element-309">
            Adolescencia
            <br data-id="element-310" />
            <span className="text-[#F4A535]" data-id="element-311">Sin Miedo</span>
          </h1>

          <p className="text-lg md:text-xl lg:text-2xl text-[#B8C8E8] italic max-w-2xl mx-auto my-5" data-id="element-312">
            "El Manual que Nadie Te Dio para Criar a un Adolescente"
          </p>

          <p className="text-base md:text-lg text-[#D4E0F0] max-w-2xl mx-auto mb-12 leading-relaxed" data-id="element-313">
            Guía práctica, basada en la ciencia y llena de esperanza para padres
            que quieren{' '}
            <strong className="text-white" data-id="element-314">
              conectar, comprender y acompañar
            </strong>{' '}
            a sus hijos durante los años más transformadores de su vida.
          </p>

          <button onClick={() => document.getElementById('precio-cta')?.scrollIntoView({
          behavior: 'smooth',
          block: 'center'
        })} className="inline-block bg-gradient-to-r from-[#F4A535] to-[#E8851A] text-[#1A2744] text-lg md:text-xl font-extrabold px-12 py-5 rounded-full shadow-[0_8px_30px_rgba(244,165,53,0.4)] transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_15px_40px_rgba(244,165,53,0.5)] cursor-pointer border-none" data-id="element-315">
            🚀 Descargar la guía ahora
          </button>

          <p className="text-xs md:text-sm text-[#8AA0C0] mt-5" data-id="element-316">
            ✅ Acceso inmediato · 📱 Compatible con cualquier dispositivo · 💰
            Garantía 7 días
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 40
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.3
      }} className="mt-16" data-id="element-317">
          <img src="https://cdn.magicpatterns.com/uploads/oGA7gidQ2NoZmnoqY6TCc2/Adolescencia_sin_miedo.png" alt="Adolescencia Sin Miedo - Mockup en iPad y iPhone" className="max-w-full h-auto mx-auto" style={{
          maxHeight: '500px'
        }} data-id="element-318" />
        </motion.div>
      </div>
    </section>;
}